import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Main Footer */}
      <footer className="bg-charcoal-900 text-cream-100 py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-4 gap-12 mb-12">
              {/* Brand */}
              <div className="md:col-span-2">
                <h3 className="text-3xl font-light mb-4 font-serif">
                  Alchemy of Polarity
                </h3>
                <p className="text-charcoal-700 leading-relaxed mb-6">
                  Transformational coaching blending psychology, astrology, and somatics for those ready to remember who they truly are.
                </p>
                <div className="flex gap-4">
                  <a
                    href="https://instagram.com/alchemyofpolarity"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-mauve-400 rounded-lg transition-all duration-300 cursor-pointer"
                  >
                    <i className="ri-instagram-line text-lg"></i>
                  </a>
                  <a
                    href="mailto:alchemyofpolarity@gmail.com"
                    className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-mauve-400 rounded-lg transition-all duration-300 cursor-pointer"
                  >
                    <i className="ri-mail-line text-lg"></i>
                  </a>
                </div>
              </div>

              {/* Quick Links */}
              <div>
                <h4 className="text-sm tracking-widest uppercase mb-6 text-charcoal-700 font-semibold">Quick Links</h4>
                <ul className="space-y-3">
                  <li>
                    <Link to="/" className="text-cream-100 hover:text-mauve-400 transition-colors duration-300">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" className="text-cream-100 hover:text-mauve-400 transition-colors duration-300">
                      About
                    </Link>
                  </li>
                  <li>
                    <Link to="/services" className="text-cream-100 hover:text-mauve-400 transition-colors duration-300">
                      Services
                    </Link>
                  </li>
                  <li>
                    <Link to="/work-with-me" className="text-cream-100 hover:text-mauve-400 transition-colors duration-300">
                      Work With Me
                    </Link>
                  </li>
                  <li>
                    <Link to="/terms" className="text-cream-100 hover:text-mauve-400 transition-colors duration-300">
                      Terms &amp; Conditions
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Contact */}
              <div>
                <h4 className="text-sm tracking-widest uppercase mb-6 text-charcoal-700 font-semibold">Get Started</h4>
                <ul className="space-y-3">
                  <li>
                    <a
                      href="https://calendly.com/alchemyofpolarity"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-cream-100 hover:text-mauve-400 transition-colors duration-300 cursor-pointer"
                    >
                      Book Discovery Call
                    </a>
                  </li>
                  <li>
                    <a
                      href="mailto:alchemyofpolarity@gmail.com"
                      className="text-cream-100 hover:text-mauve-400 transition-colors duration-300"
                    >
                      Email Me
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Bottom */}
            <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-charcoal-700 text-sm">
                © {currentYear} Alchemy of Polarity. All rights reserved.
              </p>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-charcoal-700 hover:text-mauve-400 text-sm transition-colors duration-300"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
